import { render } from "./PreviewAnswers.vue?vue&type=template&id=45ceeb8f&ts=true"
import script from "./PreviewAnswers.vue?vue&type=script&lang=ts"
export * from "./PreviewAnswers.vue?vue&type=script&lang=ts"

import "./PreviewAnswers.vue?vue&type=style&index=0&id=45ceeb8f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__